import { Component, OnInit, ViewChild  } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import * as FileSaver from 'file-saver';
import { UtilsService } from '../shared/utils-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manage-users',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {
private loader: boolean= false;
private branchData: any = [];
private companyCodes: any = [];
data: any = {};
srchData: any = {};
errorHandler: any = {};
errorHandlerEdit: any = {};
branchJson : any = [];
displayedColumns: any = [];
private editBranchData: any = [];
private deleteData: any = [];
private mandFields: any = ['companyName','companyCode'];
private mandFieldsEdit: any = ['companyName'];
private exporturl: string = this.utils.url+"/ddmf_backoff/branches/exportCSV";
private branchListUrl: string = this.utils.url+"/ddmf_backoff/branchDetails";
private addBranchUrl: string = this.utils.url+"/ddmf_backoff/branches/addbranch";
private updateBranchUrl: string = this.utils.url+"/ddmf_backoff/updatebranch";
private srchUrl: string = this.utils.url+"/ddmf_backoff/branch/search";
private companyurl: string = this.utils.url+"/ddmf_backoff/cpnycode";
private mandStatus: boolean = false;
private mandStatusEdit: boolean = false;
private showDuplicate: boolean =false;
private errorFlag: boolean = false;
private urlDelete: string;
loggedInUser: any = {};
userIdAdded : string = '';
headers: any = {};

@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;
branchStatusList: any = [{name:"Active",value:'A'},{name:"Deactivated",value:'I'}]; 
constructor(private http: Http, private utils: UtilsService, private matSnackBar: MatSnackBar, private router: Router) {
   this.loggedInUser = this.utils._checkSession({'page': 'manage-users'});
}
ngOnInit() {
	this.getData().subscribe(data => {
		this.displayedColumns = ['branchCode', 'companyName', 'companyCode', 'companyStatus', 'action'];
		this.branchData = data['_body'];
		this.branchData = JSON.parse(this.branchData);
		this.branchJson = new MatTableDataSource<Element>(this.branchData);
		this.branchJson.paginator = this.paginator;
		this.branchJson.sort = this.sort;
	});
	this.getCompanyCode().subscribe(data => {
		this.companyCodes = data['_body'];
		this.companyCodes = JSON.parse(this.companyCodes);
	});
}
getHeaders(){
	this.headers = new Headers();
	this.headers.append('Content-Type', 'application/json');
	this.headers.append('userId', this.loggedInUser.userId);
	this.headers.append('token', this.loggedInUser.token);
}
getData(){
	this.getHeaders()
	return this.http.get(this.branchListUrl,{ headers: this.headers });
}
getListData(){
	this.getData().subscribe(data => {
		this.loader=false;
		this.displayedColumns = ['branchCode', 'companyName', 'companyCode', 'companyStatus', 'action'];
		this.branchData = data['_body'];
		this.branchData = JSON.parse(this.branchData);
		this.branchJson = new MatTableDataSource<Element>(this.branchData);
		this.branchJson.paginator = this.paginator;
		this.branchJson.sort = this.sort;
	});
}
getCompanyCode(){
	this.getHeaders()
	return this.http.get(this.companyurl,{ headers: this.headers });
}
export(){
		this.getHeaders()
	  	this.http.get(this.exporturl,{ headers: this.headers }).subscribe(data => {
	    var mediaType = 'application/csv';
	                    var blob = new Blob([data['_body']], {type: mediaType});
	                    var filename = 'BranchDetails.csv';
	                    FileSaver.saveAs(blob, filename);
		});
	  }
searchBranch() {
    this.paginator.pageIndex = 0;
	this.getHeaders()
	this.loader=true;
    this.http.post(this.srchUrl,JSON.stringify({"companyName" : this.srchData.companyName,
      "branchCode" : this.srchData.branchCode,
      "companyCode" : this.srchData.companyCode}),{ headers: this.headers }).subscribe(data => {
      this.loader=false;
      let json = JSON.parse(data['_body']);
      this.branchData = json;
      this.branchJson = new MatTableDataSource<Element>(json);
      this.branchJson.paginator = this.paginator;
      this.branchJson.sort = this.sort;
    }, error => {
    this.loader=false;
      var message = error['_body'];
        this.utils.notify(message);
      this.paginator.length = 0;
      this.branchJson = [];
      this.branchData = [];
      this.branchJson.paginator = this.paginator;
      this.branchJson.sort = this.sort;
    })
  }
addBranch(){ 
    this.mandStatus = false;
   	for(let e in this.errorHandler){
   		if (this.errorHandler[e]) {
   			this.utils.notify('Please enter value for all mandatory fields');
   			this.errorFlag = true;
   		} 
   	}
    this.userIdAdded = this.data.userId;
  	if (!this.errorFlag){
		this.getHeaders()
		this.loader=true;
		this.http.post(this.addBranchUrl,JSON.stringify({
			"branchCode": this._checkNull(this.data.branchCode),
			"companyCode": this._checkNull(this.data.companyCode),
			"branchDesc": this.data.branchDesc,
			"branchAddress": this.data.branchAddress,
			"telphoneNo": this.data.telphoneNo,
			"faxNo": this.data.faxNo,
			"eMail": this.data.eMail,
		}), { headers: this.headers }).subscribe(res => {
			this.loader = false
			var message = res['_body'];
			this.utils.notify(message);
			this.getListData()
		}, 
		error => {
			this.loader=false;
			this.utils.notify(error['_body']);
		});   
  		this.data = {};
  	}
}
editBranch($event, branchDetail){
	if(branchDetail.deActivatedDate != null){
		let date = branchDetail.deActivatedDate.split(" ");
		branchDetail.deActivatedDate = date[0];
	}
	if(branchDetail.editedDate != null){
		let date = branchDetail.editedDate.split(" ");
		branchDetail.editedDate = date[0];
	}
	this.editBranchData = branchDetail;
}
editBranchDetail(){
	var editurl= this.updateBranchUrl+'/'+this.editBranchData.branchCode;
	for(let e in this.errorHandlerEdit){
		if (this.errorHandlerEdit[e]) {
			this.errorFlag = true;
			this.utils.notify('Please enter value for all mandatory fields');
		}
	}
	if (!this.errorFlag){
		this.getHeaders()
		this.loader=true;
		this.http.post(editurl,JSON.stringify({
			"branchCode": this._checkNull(this.editBranchData.branchCode),
			"companyCode": this._checkNull(this.editBranchData.companyCode),
			"branchDesc": this.editBranchData.branchDesc,
			"branchAddress": this.editBranchData.branchAddress,
			"branchStatus": this.editBranchData.branchStatus,
			"telphoneNo": this.editBranchData.telphoneNo,
			"faxNo": this.editBranchData.faxNo,
			"eMail": this.editBranchData.eMail,
			"editedBy": this.loggedInUser.userId
		}), { headers: this.headers }).subscribe(res => {
			var message = res['_body'];
			this.utils.notify(message);
			this.paginator.pageIndex = 0;
			this.getListData()
		}, error => {
			this.loader=false;
			var message = error['_body'];
			this.utils.notify(message);
		});
	}
}
reset(){
	this.paginator.pageIndex = 0;
	this.loader=true;
	this.getListData()
	this.data={};
	this.showDuplicate = false
	this.mandStatus = false
	this.errorHandler ={};
}
goToURL(url){
	this.router.navigateByUrl(url);
}		
_checkNull(value) {
	return (!value || value === null || value === 'undefined') ? '' : value;
}
mandatoryCheck(model) {
	this.mandFields = ['companyCode','branchCode'];
	let count = 0;
	let branchCodes = []
	for(let item of this.branchData){
		branchCodes.push(item.branchCode)
	}
	for(let i =0; i<this.mandFields.length; i++){
		let item = this.data[this.mandFields[i]];
		if(item ==undefined || item ==""){
			this.errorHandler[this.mandFields[i]] = true;
			count++;
		} else {
			if(branchCodes.includes(item)){
				this.showDuplicate = true
			}
			else {
				this.showDuplicate = false
			}
			this.errorHandler[this.mandFields[i]] = false;
		}
	}
	if(count == 0){
		this.mandStatus = false;
	} else {
		this.mandStatus = true;
	}
}
mandatoryCheckEdit(editMember) {
	let countEdit = 0;
	this.mandFieldsEdit = ['companyCode','branchCode'];
	for(let i =0; i<this.mandFieldsEdit.length; i++){
		let item = this.editBranchData[this.mandFieldsEdit[i]];
		if(item =="" || item ==null){
			this.errorHandlerEdit[this.mandFieldsEdit[i]] = true;
			countEdit++;
		} else {
			this.errorHandlerEdit[this.mandFieldsEdit[i]] = false;
		}
	}
	if(countEdit == 0){
	this.mandStatusEdit = false;
	} else {
	this.mandStatusEdit = true;
	}
}
}




// WEBPACK FOOTER //
// ./src/app/branch/branch.component.ts